/*
 * <event-sticky-cta> — a hovering footer CTA.
 *
 * - action="scroll": smooth-scrolls to a target (the dates list on a
 *   collection page).
 * - action="add": submits the page's real Dawn product form
 *   (requestSubmit) so the currently-selected variant is added to cart —
 *   the form is never rebuilt.
 *
 * Visibility: shown once the visitor has scrolled down, and hidden while
 * the target (dates list / main buy form) is already on screen, so it
 * never duplicates the primary CTA.
 */
if (!customElements.get('event-sticky-cta')) {
  customElements.define(
    'event-sticky-cta',
    class EventStickyCta extends HTMLElement {
      connectedCallback() {
        this.action = this.dataset.action;
        this.target = this.dataset.target ? document.querySelector(this.dataset.target) : null;
        if (!this.target && this.dataset.fallback) this.target = document.querySelector(this.dataset.fallback);
        this.btn = this.querySelector('[data-sticky-action]');
        if (this.btn) this.btn.addEventListener('click', this.onClick.bind(this));

        this.onScroll = this.onScroll.bind(this);
        this.ticking = false;
        this.scheduleUpdate = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.onScroll();
            this.ticking = false;
          });
        };
        window.addEventListener('scroll', this.scheduleUpdate, { passive: true });
        window.addEventListener('resize', this.scheduleUpdate, { passive: true });
        this.onScroll();
      }

      onScroll() {
        const scrolledEnough = window.scrollY > 400;
        let targetVisible = false;
        if (this.target) {
          const r = this.target.getBoundingClientRect();
          targetVisible = r.top < window.innerHeight * 0.9 && r.bottom > 0;
        }
        const show = scrolledEnough && !targetVisible;
        this.classList.toggle('is-visible', show);
        // Lift the store's floating chat widget above the bar while it's shown
        // (see event-sticky-cta.liquid), so the two don't overlap on mobile.
        document.documentElement.classList.toggle('event-sticky-visible', show);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.scheduleUpdate);
        window.removeEventListener('resize', this.scheduleUpdate);
        document.documentElement.classList.remove('event-sticky-visible');
      }

      onClick() {
        if (this.action === 'scroll' && this.target) {
          this.target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else if (this.action === 'add') {
          const form = document.querySelector('product-info product-form form') || document.querySelector('product-form form');
          if (form) {
            if (typeof form.requestSubmit === 'function') form.requestSubmit();
            else form.querySelector('[type="submit"], [name="add"]')?.click();
          }
        }
      }
    }
  );
}
